<template>
  <v-card tile>
    <div :style="{ height: '300px' }">
      <blurred-margin-poster :src="image" :to="{ path: '/work/' + review.work.medium + '/' + review.work.id }">
        <medium-icon :medium="medium" />
        <rating-circle class="rating-circle" :size="72" :rating="rating" :opacity="0.65"></rating-circle>
      </blurred-margin-poster>
    </div>

    <div class="review-content">
      <v-card-title class="review-title text-h5 justify-center">
        {{ title }}
      </v-card-title>

      <v-card-actions>
        <v-btn rounded color="primary" @click="$router.push({ path: '/review/' + review.id })">Go To Review</v-btn>
        <v-spacer></v-spacer>

        <v-btn
          v-if="username === $store.state.username"
          :to="{ name: 'review', params: { id: review.id } }"
          rounded
          color="primary"
          >Edit</v-btn
        >

        <!-- Delete Button and confirmation -->
        <v-dialog v-model="deleteDialog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="username === $store.state.username"
              color="primary"
              rounded
              v-bind="attrs"
              v-on="on"
              class="ml-2"
            >
              <span class="red--text">Delete</span>
            </v-btn>
          </template>

          <!-- Delete Confirmation -->
          <v-card>
            <v-card-title class="justify-center"> Are you sure you want to delete this post? </v-card-title>
            <v-card-actions>
              <v-btn @click="deleteDialog = false"> No </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                @click="
                  deleteReview(id);
                  deleteDialog = false;
                "
              >
                Yes
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-btn v-if="username !== $store.state.username" @click="handleReportButton" color="primary" rounded>
          <span class="red--text">Report</span>
        </v-btn>
      </v-card-actions>

      <v-card-text class="review-text">{{ text }}</v-card-text>
    </div>

    <v-divider></v-divider>

    <v-expansion-panels flat v-if="comments.length > 0">
      <v-expansion-panel>
        <v-expansion-panel-header>Comments</v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-list>
            <v-list-item v-for="comment in comments" :key="comment.id">
              <profile-avatar :username="comment.author.username" :size="32" class="mr-2"> </profile-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ comment.author.username }}</v-list-item-title>

                <p class="comment-text">{{ comment.content }}</p>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<style scoped>
/* #review-drawer { top: 60px !important; } */

.medium-icon {
  position: absolute !important;

  left: 0;
  top: 0;

  max-width: 40px;
  margin: 12px;

  background-color: rgba(0, 0, 0, 0.5);
}

.rating-circle {
  position: absolute !important;

  right: 0;
  top: 0;

  margin: 12px;
}

.review-reviewer {
  position: absolute !important;

  left: 0;
  bottom: 0;

  margin: 12px;
}

/*
		Review Content
	*/
.review-content {
  position: relative;
}

.review-content > .review-title {
  text-align: center;

  width: calc(100% - 32px);

  padding: 8px 0;
  margin: 0 16px;

  word-break: normal;
}

.review-text {
  white-space: pre-wrap;
}

.comment-text {
  color: #666666;
  margin-bottom: 0;
}
</style>

<script>
import ratingCircle from "../rating-circles/rating-circle-monochrome.vue";
import { mapMutations } from "vuex";
import deleteReview from "../../mixins/deleteReview.js";
import BlurredMarginPoster from "@/components/poster-blurred-margins.vue";

export default {
  name: "review-drawer",

  props: {
    review: { type: Object, default: () => ({}) },
  },

  components: {
    BlurredMarginPoster,
    ratingCircle,
  },

  mixins: [deleteReview],

  data: () => {
    return {
      deleteDialog: false,
    };
  },

  computed: {
    medium() {
      return this.review.work.medium ? this.review.work.medium : "";
    },
    image() {
      return this.review.work.posterSource ? this.review.work.posterSource : require("../../../public/unknown.png");
    },
    username() {
      return this.review.author.username ? this.review.author.username : "";
    },
    title() {
      if (!this.review.work || !this.review.work.title) return "Unknown Title";
      return this.review.work.title;
    },
    text() {
      return this.review.review ? this.review.review : "";
    },
    rating() {
      return this.review.rating ? this.review.rating : 0;
    },
    id() {
      return this.review.id ? this.review.id : 0;
    },
    comments() {
      console.log(this.review.comments.items);
      return this.review.comments.items;
    },
  },

  mounted() {
    this.$root.$on("delete-review", () => {
      this.closeDrawer();
    });
  },

  methods: {
    ...mapMutations(["closeDrawer", "showReportPopup"]),

    handleReportButton() {
      console.log(this.id);
      this.showReportPopup({
        contentId: this.id,
        contentType: "review",
      });
    },
  },
};
</script>
